import { createTestAdminApi } from './placement-tests.services';

/**
 * Админские запросы детского теста. Эндпоинты и формат ответов те же, что у
 * взрослого Placement Test, — отличается только префикс пути. Сервер под этим
 * префиксом отдаёт шаблоны и сессии только детского теста, поэтому раздел
 * админки не может ни увидеть, ни изменить взрослый тест.
 */
const kidsTestAdminApi = createTestAdminApi('/admin/kids-tests');

export const getAdminKidsTestTemplates = kidsTestAdminApi.getTemplates;
export const getAdminKidsTestTemplateById = kidsTestAdminApi.getTemplateById;
export const createAdminKidsTestTemplate = kidsTestAdminApi.createTemplate;
export const updateAdminKidsTestTemplate = kidsTestAdminApi.updateTemplate;
export const deleteAdminKidsTestTemplate = kidsTestAdminApi.deleteTemplate;
export const getAdminKidsTestSessions = kidsTestAdminApi.getSessions;
export const getAdminKidsTestSessionById = kidsTestAdminApi.getSessionById;
export const deleteAdminKidsTestSession = kidsTestAdminApi.deleteSession;
